import Swiper from "swiper";
import { Autoplay } from "swiper/modules";
class CareerSwiper {
  constructor() {
    if (document.querySelector('.careers-image_slider__swiper')) {
      this.init()
    }
  }
  init() {
    var swiper = new Swiper(".careers-image_slider__swiper", {
      slidesPerView: 2.25,
      spaceBetween: 23,
      centeredSlides: true,
      loop: true,
      autoplay: {
        disableOnInteraction: false,
        delay: 0
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1.4,
          spaceBetween: 20
        },
        // when window width is >= 640px
        700: {
          slidesPerView: 2.5,
          spaceBetween: 40
        }
      },
      speed: 7000,
      keyboard: true,
      modules: [Autoplay],
    })
    swiper.slideTo(2, false, false);
  }
}
export default CareerSwiper;